import { useState } from "react";
import { TextField } from "@mui/material";
import { useCustomHook } from "../../../../GlobalFunctions/globalFunctions";
import DropdownIcon from "../../../components/DropdownIcon/DropdownIcon";
import {
  CONTRACT_MODAL_ACTION_TYPE,
  COURSES_MODAL_ACTION_TYPE,
} from "../../../../../redux/actions-type";
import { useDispatch } from "react-redux";

const ContractTypes = ({ formik, modalData }) => {
  const { contractTypesList: dataList } = useCustomHook();
  const [openDropdown, setOpenDropdown] = useState(false);
  const dispatch = useDispatch();

  const updateModalState = (item) => {
    dispatch({
      type: CONTRACT_MODAL_ACTION_TYPE.GET_CONTRACT_MODAL,
      payload: {
        data: { ...modalData, contractType: item.key },
        openModal: true,
      },
    });

    setOpenDropdown(false);
  };

  return (
    <div className="dropdown-input  courses">
      <div className="left">
        <div className="input-box">
          <TextField
            sx={{
              "& input": {
                fontSize: "12px",
                marginRight: "32px",
              },
              marginTop: "24px",
            }}
            InputLabelProps={{
              style: { fontSize: "12px", color: "#3F3F3F" },
            }}
            fullWidth
            label="Müqavilə növü"
            autoComplete="off"
            disabled
            value={
              modalData.contractType
                ? dataList.find((item) => item.key === modalData.contractType)
                    ?.name
                : ""
            }
          />
          <DropdownIcon
            setOpenDropdown={setOpenDropdown}
            openDropdown={openDropdown}
          />
        </div>

        <ul className={`dropdown-body ${openDropdown ? "active" : ""}`}>
          {dataList.map((item) => (
            <li key={item.key} onClick={() => updateModalState(item)}>
              <h4>{item.name}</h4>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ContractTypes;
